module.exports = __webpack_public_path__ + "img/Search.c3a783d8.svg";